import {http} from '../utils'
// 营销分组管理 start
// 查询
const searchAction = (params) => {
  const url = `/market/management/email/task/page`
  return http.post(url, params)
}
// 查询 已完成
const searchComplateAction = (params) => {
  const url = `/market/management/email/task/list`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (type) => {
  const url = `/market/common/codeList/${type}`
  return http.post(url)
}
// 获取group列表
const getGroup = (params) => {
  const url = '/market/management/group/all'
  return http.post(url, params)
}
// 获取模板列表
const getTemplate = (params) => {
  const url = `/market/management/email/template/list`
  return http.post(url, params)
}
// 获取域名列表
const getHttp = (params) => {
  const url = '/market/management/email/task/domain/list'
  return http.post(url, params)
}
// 获取发送人列表
const getSender = (params) => {
  const url = '/market/management/email/task/domain/account/list'
  return http.post(url, params)
}
// 获取联系人列表
const getConcater = (params) => {
  const url = '/market/management/email/list'
  return http.post(url, params)
}
// 获取 详情
const getAction = (id) => {
  const url = `/market/management/group/detail/${id}`
  return http.post(url)
}
// 新建
const addAction = (params) => {
  const url = `/market/management/email/task/add`
  return http.post(url, params)
}
// 编辑
const editAction = (params) => {
  const url = `/market/management/email/task/edit`
  return http.post(url, params)
}
// 删除
const deleteAction = (params) => {
  const url = `/market/management/email/task/del/${params}`
  return http.post(url)
}

// 活跃邮箱统计
const emailTotalAction = (params) => {
  const url = `/market/management/email/task/track`
  return http.post(url, params)
}
// 发送统计
const sendTotalAction = (params) => {
  const url = `/market/management/email/task/statistics`
  return http.post(url, params)
}
// 投递失败统计数据
const failedStatisticsAction = (params) => {
  const url = `/market/management/email/task/failed/statistics`
  return http.post(url, params)
}
// 展会届次列表
const expoAction = (params) => {
  const url = `/market/common/resume`
  return http.post(url, params)
}
// 查询地址
const addressAction = (params) => {
  const url = `/market/management/email/address/list`
  return http.post(url, params)
}
// 添加地址
const addAddressAction = (params) => {
  const url = `/market/management/email/address/add`
  return http.post(url, params)
}
// 清空地址
const clearAddressAction = (params) => {
  const url = `/market/management/email/address/delete`
  return http.post(url, params)
}
// 获取手机号统计结果
const statisticsAction = (params) => {
  const url = `/market/management/email/statistics`
  return http.post(url, params)
}
// 获取getResourcePool列表
const getResourcePool = (params) => {
  const url = '/market/management/resource/all'
  return http.post(url, params)
}
// 同意 拒绝
const agreeAction = (params) => {
  const url = `/market/management/email/task/approve`
  return http.post(url,params)
}
// 失败批次重新发送
const reSendAction = (params) => {
  const url = `/market/management/email/task/reSend`
  return http.post(url, params)
}
// 查询发送数量
const getAddressList = (params) => {
  const url = `/market/management/email/address/detail/list`
  return http.post(url,params)
}
// 获取发送统计信息
const getSendStatistics = (params) => {
  const url = `/market/management/email/task/real/send/statistics`
  return http.post(url,params)
}
// 发送测试邮件
const sendTestEmail=(params)=>{
  const url = `/market/management/email/send/test`
  return http.post(url,params)
}

export default {
  searchAction,
  searchComplateAction,
  getStatus,
  getGroup,
  getTemplate,
  getHttp,
  getSender,
  getConcater,
  getAction,
  addAction,
  editAction,
  deleteAction,
  emailTotalAction,
  failedStatisticsAction,
  sendTotalAction,
  expoAction,
  addressAction,
  addAddressAction,
  clearAddressAction,
  statisticsAction,
  getResourcePool,
  agreeAction,
  reSendAction,
  getAddressList,
  getSendStatistics,
  sendTestEmail
}
